var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"link",on:{"click":function($event){return _vm.localtions()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }